export default "__VITE_ASSET__DRZq8lAO__"